/**
 * BulkTankManager to manage the bulk tanks.
 * Finds of which are fuel/consumbles.
 * Handles import/export of bulk tanks with voyage bulk.
 *
 *
 */
var VRC = VRC || {};

VRC.BulkTankManager = (function () {
	var _bulkTanksIndex = {};
	var _bulkTanks = [];
	var _consumable = [];

	var createBulkTankObjects = function (bulkTanks) {
		_bulkTanks = [];
		_consumable = [];
		_.each(bulkTanks, function (bulkTank) {

			var bulkTankObject = VRC.BulkTank(bulkTank);
			_bulkTanks.push(bulkTankObject);

			if (bulkTankObject.isConsumable()) {
				_consumable.push(bulkTankObject);
			}
		});
	};

	var getConsumable = function () {
		return _consumable;
	};

	var getFuelTanks = function () {
		var fuelTanks = getConsumable();
		fuelTanks = fuelTanks.filter(function (bulkTank) {
			return bulkTank.isFuelConsumable();
		});

		return fuelTanks;
	};

	var clearTanks = function () {

		_.each(_bulkTanks, function (bulkTank) {
			bulkTank.clearTank();
		})
	};

	var importBulkData = function (flattenContent) {

		var groupedContent = _.groupBy(flattenContent, function (e) {
			return e.bulkTankId
		});
		$.each(groupedContent, function (bulkTankId, contentArray) {
			var bulkTank = getBulkTankById(bulkTankId);
			bulkTank.fillTank(contentArray);

		});

	};

	/**
	 * Adds tankId to list.
	 * @param robNumber
	 * @param tankId
	 */
	var setBulkTankId = function (robNumber, tankId) {
		_bulkTanksIndex[robNumber - 1] = tankId;
	};

	/**
	 * Gets tankId fom list.
	 * @return bulktank id.
	 * @param robNumber
	 */
	var getBulkTankId = function (robNumber) {
		return _bulkTanksIndex[robNumber - 1];
	};

	/**
	 * Returns array of id for consumable tanks
	 * @return array with ids
	 */
	var getBulkTanks = function () {
		return _bulkTanks;
	};

	var getBulkTankById = function (bulkTankId) {
		bulkTankId = parseInt(bulkTankId);
		return _.find(_bulkTanks, function (bulkTank) {
			return bulkTank.getBulkTankId() === bulkTankId;
		});
	};

	/**
	 * Get all actions of type and summarizes the quantiy for each unit of measure.
	 * @param type load/offload
	 * @param fromDate accepts moment and string format
	 * @param toDate accepts moment and string format
	 * @returns an object with key value {unit : value} e.g {m3 : 1400, kg : 123}
	 */
	var getBulkContentSumInDateInterval = function (type, fromDate, toDate) {
		var bulkInDateRange = getBulkContentInInterval(type, fromDate, toDate);

		var indexUnits =  _.chain(bulkInDateRange)
			.groupBy(function (bulk) {
				return bulk.getValueUnit()
			}).map(function(group, key){

				var summarizedQty = _.reduce(group, function (sum, bulkAction) {
					return sum + bulkAction.getValueQty();
				}, 0);

				return {value: summarizedQty, unit : key};
			}).indexBy('unit').value();

		_.each(indexUnits, function(valueObject, unit){
			indexUnits[unit] = valueObject.value;
		});

		return indexUnits;


	};

	var getBulkContentInInterval = function (type, fromDate, toDate) {

		if (!moment.isMoment(fromDate)) {
			fromDate = moment(fromDate, g_timeStampFormat);
		}

		if(toDate && !moment.isMoment(toDate)){
				toDate = moment(toDate, g_timeStampFormat);
		}


		var filter = function (content) {
			if (content.getAction() !== type) {
				return false;
			}
			var date = moment(content.getDate(), g_timeStampFormat);
			if(toDate){
				return date.isBetween(fromDate, toDate, null, '[)');
			}
			else{
				return date.isSame(fromDate) || date.isAfter(fromDate);
			}
		};

		return getAllContent(filter)
	};

	var getAllContent = function (filter) {

		var content = _.chain(_bulkTanks).map(function (bulkTank) {
			return bulkTank.getContent()
		}).flatten().value();
		if (filter) {
			content = _.filter(content, filter);
		}
		return content;

	};

	var findLoadedCargoItems = function () {
		var loadedCargo = {};
		var deviationTank = VRC.SpecialBulkTanks.getDeviationTank();

		var allTanks = _bulkTanks.concat([deviationTank]);

		_.each(allTanks, function (bulkTank) {
			var bulkTankCargo = bulkTank.getContent();
			_.each(bulkTankCargo, function (voyageBulk) {
				var containerId = voyageBulk.getContainerId();
				var cargoItemId = voyageBulk.getCargoItemId();

				if (containerId
					&&
					(
						(voyageBulk.getAction() === g_actions.load)
						||
						(voyageBulk.getAction() === g_actions.deviation && bulkTank.isSpecialTank())
					)
				) {

					if (cargoItemId) {
						if (loadedCargo[containerId]) {
							loadedCargo[containerId] = loadedCargo[containerId] += voyageBulk.getValueQty();
						} else {
							loadedCargo[containerId] = voyageBulk.getValueQty();
						}
					} else { //Ad - hoc
						loadedCargo[containerId] = Infinity;
					}
				}
			});
		});

		return loadedCargo;
	};

	var getOffloadEvents = function (portId) {

		return _.chain(_bulkTanks)
			.map(function (bulkTank) {
				return bulkTank.getContent()
			})
			.flatten()
			.filter(function (item) {
				return item.isOffloadAction() && item.getOriginId() == portId
			})
			.map(function (item) {
				return item.toJson()
			}).value();
	};

	var toJson = function () {
		var bulkTanks = [];
		$.each(getBulkTanks(), function (bulkTankId, bulkTank) {
			bulkTanks.push(bulkTank.toJson());
		});

		return bulkTanks;
	};

	var getBulkTanksNameAndId = function (ignoreId) {
		var bulkTanks = [];
		_.each(getBulkTanks(), function (bulkTank) {
			var id = bulkTank.getBulkTankId();
			if (id !== ignoreId) {
				bulkTanks.push({id: id, name: bulkTank.getName()});
			}

		});

		return _.sortBy(bulkTanks, function (bulkTank) {
			return bulkTank.name;
		});
	};

	var isInitialised = function () {
		return _bulkTanks.length > 0;
	};

	return {

		setBulkTankId: setBulkTankId,
		getBulkTankId: getBulkTankId,
		getBulkTanks: getBulkTanks,
		getConsumable: getConsumable,
		getFuelTanks: getFuelTanks,
		getBulkTankById: getBulkTankById,
		findLoadedCargoItems: findLoadedCargoItems,
		clearTanks: clearTanks,
		importBulkData: importBulkData,
		toJson: toJson,
		isInitialised: isInitialised,
		createBulkTankObjects: createBulkTankObjects,
		getOffloadEvents: getOffloadEvents,
		getBulkTanksNameAndId: getBulkTanksNameAndId,
		getAllContent: getAllContent,
		getBulkContentInInterval: getBulkContentInInterval,
		getBulkContentSumInDateInterval: getBulkContentSumInDateInterval
	}
})();


